import { c as _c } from "react/compiler-runtime";
import { DocumentUploadSettings, type IdDocImageTypes } from '@onefootprint/types';
import { NavigationHeader } from '@/idv/components';
import { useCountryName } from '@/idv/hooks/use-country-name';
import ErrorComponent from '../../../components/error';
import FadeInContainer from '../../../components/fade-in-container';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import type { ReceivedImagePayload } from '../../../types';
import { isSelfie } from '../../../utils/capture';
import useDocName from '../../hooks/use-doc-name';
import { useIdDocMachine } from '../machine-provider';
type CaptureRetryPromptProps = {
  imageType: `${IdDocImageTypes}`;
  onComplete: (payload: ReceivedImagePayload) => void;
};
const CaptureRetryPrompt = t0 => {
  const $ = _c(38);
  const {
    imageType,
    onComplete
  } = t0;
  const [state, send] = useIdDocMachine();
  const getCountryName = useCountryName();
  const {
    errors,
    hasBadConnectivity,
    idDoc,
    requirement,
    allowPdf
  } = state.context;
  const docType = idDoc.type;
  const docCountry = idDoc.country;
  let t1;
  if ($[0] !== docType || $[1] !== imageType) {
    t1 = {
      docType,
      imageType
    };
    $[0] = docType;
    $[1] = imageType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    getDocName,
    getSideName
  } = useDocName(t1);
  if (!docType || !docCountry) {
    return null;
  }
  let t2;
  if ($[3] !== getDocName) {
    t2 = getDocName();
    $[3] = getDocName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const docName = t2;
  let t3;
  if ($[5] !== getSideName) {
    t3 = getSideName();
    $[5] = getSideName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const sideName = t3;
  let t4;
  if ($[7] !== docCountry || $[8] !== getCountryName) {
    t4 = getCountryName(docCountry) || docCountry;
    $[7] = docCountry;
    $[8] = getCountryName;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const countryName = t4;
  let t5;
  if ($[10] !== imageType) {
    t5 = isSelfie(imageType);
    $[10] = imageType;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const hideUploadButton = t5;
  const hideUpload = hideUploadButton || requirement.uploadSettings === DocumentUploadSettings.captureOnlyOnMobile || requirement.uploadSettings === DocumentUploadSettings.requireMobileCapture;
  let t6;
  if ($[12] !== imageType || $[13] !== send) {
    t6 = isSelfie(imageType) ? undefined : {
      variant: "back",
      onBack: () => send({
        type: "navigatedToCountryDoc"
      })
    };
    $[12] = imageType;
    $[13] = send;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <NavigationHeader position="floating" leftButton={t6} />;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== errors) {
    t8 = errors || [];
    $[17] = errors;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== countryName || $[20] !== docName || $[21] !== sideName || $[22] !== t8) {
    t9 = <ErrorComponent docName={docName} sideName={sideName} errors={t8} countryName={countryName} />;
    $[19] = countryName;
    $[20] = docName;
    $[21] = sideName;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== send) {
    t10 = () => send({
      type: "startImageCapture"
    });
    $[24] = send;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== allowPdf || $[27] !== hasBadConnectivity || $[28] !== hideUpload || $[29] !== onComplete || $[30] !== t10) {
    t11 = <IdDocPhotoButtons onComplete={onComplete} hideUploadButton={hideUpload} onTakePhoto={t10} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} />;
    $[26] = allowPdf;
    $[27] = hasBadConnectivity;
    $[28] = hideUpload;
    $[29] = onComplete;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t9) {
    t12 = <div className="h-full flex flex-col gap-6 items-center justify-center">{t9}{t11}</div>;
    $[32] = t11;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t7) {
    t13 = <FadeInContainer>{t7}{t12}</FadeInContainer>;
    $[35] = t12;
    $[36] = t7;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
export default CaptureRetryPrompt;